<template>
  <section>
    <left-menu/>

    <button-back v-if="routeBack" :btnRoute="routeBack"/>

    <div id="mainContent" class="day-detail">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">{{ $t("Detalhes do dia") }}</h1>
        </div>

        <loading-page v-if="loadingRequest" />

        <div v-else class="col-xs-12 col-sm-12 col-md-12 default-box box-detail-day-user box-day-info offset-top-30">
          <!-- Informações usuário -->
          <div class="col-xs-12 col-md-12 user-info">
            <div class="col-md-2 photo">
              <div v-if="!loadingRequest" class="col-md-12 padding-null">
                <img v-if="dataDayDetail.user.photo" v-bind:src="dataDayDetail.user.photo" class="img-responsive center_horizontal" alt="foto do usuário">
                <img v-if="!dataDayDetail.user.photo" src="../../../../assets/img/user-default.png" class="img-responsive center_horizontal" alt="foto do default">
              </div>
            </div>

            <div class="col-md-4 offset-top-20 detail">
              <p v-if="dataDayDetail.user.name"><strong>{{ $t("Nome:") }}</strong> <span>{{dataDayDetail.user.name}}</span></p>
              <p v-if="dataDayDetail.user.email"><strong>{{ $t("Email:")}}</strong> <span>{{dataDayDetail.user.email}}</span></p>
              <p v-if="dataDayDetail.user.team"><strong>{{ $t("Equipe:")}}</strong> <span>{{dataDayDetail.user.team}}</span></p>
            </div>

            <div class="col-md-6 offset-top-20 detail">
              <p v-if="dataDayDetail.user.workShift"><strong>{{ $t("Nome do Turno:")}}</strong> <span>{{dataDayDetail.user.workShift}}</span></p>
              <p v-if="dataDayDetail.user.workShiftType"> <strong>{{ $t("Tipo do Turno:")}}</strong> {{dataDayDetail.user.workShiftType}}</p>
            </div>
          </div>

          <!-- Dis/situação -->
          <div class="col-xs-12 col-md-12 detail-info-day offset-top-30">
            <div class="header-date" v-bind:class="{'bk-no-register': dataDayDetail.dayStatus === 0, 'bk-interval': dataDayDetail.dayStatus === 1, 'bk-working': dataDayDetail.dayStatus === 2, 'bk-success-day': dataDayDetail.dayStatus === 3, 'bk-oc-day': dataDayDetail.dayStatus === 4, 'bk-ft-day': dataDayDetail.dayStatus === 5}">
              <h3>{{dataDayDetail.date | strDay}} - {{dataDayDetail.date | formatDate}} </h3>
            </div>
            <div class="body-status" v-bind:class="{'bd-no-register': dataDayDetail.dayStatus === 0, 'bd-interval': dataDayDetail.dayStatus === 1, 'bd-working': dataDayDetail.dayStatus === 2, 'bd-success-day': dataDayDetail.dayStatus === 3, 'bd-oc-day': dataDayDetail.dayStatus === 4, 'bd-ft-day': dataDayDetail.dayStatus === 5}">
              <p>{{ $t("Situação do dia")}} <strong>{{dataDayDetail.dayStatusStr}} </strong></p>
            </div>
          </div>

          <!-- Cards de horas -->
          <div class="col-xs-12 col-md-12 padding-null user-card-info offset-top-20">
            <div class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card needWork-card">
                <p>{{ $t("Horas necessárias") }}</p>
                <p>{{dataDayDetail.needWork}}</p>
              </div>
            </div>

            <div class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card success-card">
                <p>{{ $t("Horas trabalhadas") }}</p>
                <p>{{dataDayDetail.worked}}</p>
              </div>
            </div>

            <div class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card pause-excedent">
                <p> {{ $t('Horas extras') }} <i v-if="dataDayDetail.toleranceWarning"  v-bind:title="dataDayDetail.toleranceWarning" class="cursor fa fa-exclamation-triangle" aria-hidden="true"></i></p>
                <p>{{dataDayDetail.extraTime}}</p>
              </div>
            </div>

            <div v-if="dataDayDetail.justify" class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card justify-he">
                <p>{{ $t('Justificar H.E') }}</p>
                <p>{{dataDayDetail.justifyText}}</p>
              </div>
            </div>

            <div class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card fault-card">
                <p>{{ $t('Horas faltantes') }} <i v-if="dataDayDetail.toleranceWarning" v-bind:title="dataDayDetail.toleranceWarning" class="cursor fa fa-exclamation-triangle" aria-hidden="true"></i></p>
                <p>{{dataDayDetail.missingTime}}</p>
              </div>
            </div>

            <div class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card interval-need-card">
                <p>{{ $t('Tempo de intervalo necessário') }}</p>
                <p>{{dataDayDetail.intervalNeed}}</p>
              </div>
            </div>

            <div class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card interval-card">
                <p>{{ $t('Tempo de intervalo realizado') }}</p>
                <p>{{dataDayDetail.totalInterval}}</p>
              </div>
            </div>

            <div v-if="showCardPause" class="col-md-3 text-center offset-top-20">
              <div class="col-md-12 box-hours-card pause-card">
                <p>{{ $t('Tempo de pausa') }}</p>
                <p>{{dataDayDetail.totalInPause}}</p>
              </div>
            </div>
          </div>

          <!-- Timeline-->
          <div class="col-xs-12 col-md-12 offset-top-20">
            <div v-if="dataDayDetail.listPoint.length || dataDayDetail.listPause.length">
              <h3 class="title-timeline">{{ $t('Linha do tempo') }}</h3>
            </div>
            <div v-if="dataDayDetail.listPoint.length" class="caption">
              <span class="caption-subject">{{ $t('Registros de ponto') }}</span>
            </div>
            <ul v-if="dataDayDetail.listPoint.length" class="timeline-point">
              <li v-for="dt in dataDayDetail.listPoint">
                <div class="username">
                  <p></p>
                </div>
                <div class="timestamp">
                  <p>{{dt.hour}}</p>
                </div>
                <div class="status" v-bind:class="{'warning': dataDayDetail.dayStatus === 4, 'danger': dataDayDetail.dayStatus === 5}" v-bind:style="{'height': '94px'}">
                  <p>
                    <a v-bind:href="dt.image" target="_blank"><img v-if="dt.image" v-bind:src="dt.image" alt="Funcionário" class="img-user"></a>
                    <a v-on:click="saveLatLng(dt.latitude, dt.longitude)" v-bind:href="'/local-do-ponto/'" target="_blank" v-if="dt.latitude" ><i class="fa fa-map-marker cursor" aria-hidden="true"></i></a>
                    <i v-if="!dt.image && !dt.latitude || !dt.latitude" class="fa fa-map-marker hidden-icon" aria-hidden="true"></i>
                  </p>
                </div>
              </li>
            </ul>

            <div v-if="dataDayDetail.listPause.length" class="caption">
              <span class="caption-subject">{{ $t('Registros de pausa') }}</span>
            </div>
            <ul v-if="dataDayDetail.listPause.length" class="timeline-point">
              <li v-for="dt in dataDayDetail.listPause">
                <div class="pause">
                  <p v-bind:title="dt.pauseMotive">{{dt.pauseMotive}}</p>
                  <p v-bind:title="dt.totalInPause">{{dt.totalInPause}}&nbsp;</p>
                </div>
                <div class="timestamp">
                  <p>{{dt.enteredIn | formatHours}} - {{dt.exitIn | formatHours}}</p>
                </div>
                <div class="status" v-bind:style="{'height': '40px'}">

                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue'
  import buttonBack from "../../components/buttonBack";
  import loadingPage from "../../components/loadingPage";

  import swal from 'sweetalert';

  import { DAY_DETAIL } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import vueFooter from "../../components/footer.vue";

  export default {
    name: 'dayDetail',
    components: {
      vueFooter,
      leftMenu,
      loadingPage,
      buttonBack,
    },
    data() {
      return {
        routeBack: '',
        showCardPause: JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause,
        loadingRequest: false,
        failRequest: false,
        dataDayDetail: {
          user: {},
          listPoint: [],
          listPause: []
        }
      }
    },
    methods: {
      saveLatLng(lat, lng) {
        window.localStorage.removeItem('pointRegisterLatLng');
        window.localStorage.setItem('pointRegisterLatLng', JSON.stringify({lat: lat, lng: lng}));
      },
      getDetailFromDay() {
        this.loadingRequest = true;

        REQUEST_SERVICE.get(DAY_DETAIL + this.$route.params.idDay).then((response) => {
          UTIL_SERVICE.console("RESULT DAY_DETAIL:", response.data);

          this.dataDayDetail = response.data;
          this.loadingRequest = false;
          this.failRequest = false;
        }).catch(reason => {
          this.failRequest = true;
          this.loadingRequest = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal(this.$t("Aviso"), value.value, "error");
          });
        });
      },
    },
    beforeMount() {
      switch (this.$route.params.routeB) {
        case "1":
          this.routeBack = "/gestao-de-ponto";
          break;
        default:
          this.routeBack = null;
          break;
      }

      this.getDetailFromDay();
    }
  }
</script>

<style lang="scss">
.justify-he {
  background-color: #fd9a5d;
  border: 1px solid #b4b4b4;
}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/dayDetail/dayDetail.vue